import { OutlinedTextFieldProps, TextField as MuiTextField } from "@mui/material";
import { Controller } from "react-hook-form";


const MTextField = (props) => {
    const {control, ...rest} = props;
    if (control) {
        return (
            <Controller
                name={rest.name}
                control={control}
                render={(field) => (
                    <Input {...rest} {...field} helperText={props?.error} />
                )}
            />
        )
    }
    return (
        <Input {...props}
            helperText={props?.error}
        />
    )
}

const Input = (props) => {
    const {sx, ref, startAdornment, ...rest} = props;
    return <MuiTextField
        inputRef={ref}
        variant={"outlined"}
        error={props?.error ? true : false}
        slotProps={{
            input: {
                startAdornment: startAdornment
            },
        }}
        {...rest} />;
}

export {
    MTextField
}
